export default __webpack_public_path__ + "static/media/prev-Multi-GNSS-Modules-1.900becd6.png";